import { Box, Typography } from "@mui/material";
import React from "react";

export default function SelectedMaterialsBox({ selectedRows }) {
  return (
    <>
      <Typography variant="h6">Selected Materials are :</Typography>
      {selectedRows?.rows?.map((row) => {
        if (row.original?.description) {
          return (
            <Box
              sx={{
                backgroundColor: "hsla(250, 86%, 97%, 1)",
                mb: "3px",
                p: 1,
                borderRadius: "5px",
              }}
              key={row.original?.description}
            >
              - {row.original?.description} / QTY = {row.original?.id?.length}
            </Box>
          );
        }
        return row.original?.tagNumber?.map((tagNumber) => {
          return (
            <Box
              sx={{
                backgroundColor: "hsla(250, 86%, 97%, 1)",
                mb: "3px",
                p: 1,
                borderRadius: "5px",
              }}
              key={tagNumber}
            >
              - {tagNumber} / {row.original.materialCode}
            </Box>
          );
        });
      })}
    </>
  );
}
